// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

frappe.provide("erpnext");

// preferred modules for breadcrumbs
$.extend(frappe.breadcrumbs.preferred, {
	"Item Group": "Stock",
	"Customer Group": "Selling",
	"Supplier Group": "Buying",
	Territory: "Selling",
	"Sales Person": "Selling",
	"Sales Partner": "Selling",
	Brand: "Selling",
	"Maintenance Schedule": "Support",
	"Maintenance Visit": "Support",
	"Sales Order": "Selling",
});

$.extend(frappe.breadcrumbs.module_map, {
	"ERPNext Integrations": "Integrations",
	Geo: "Settings",
	Portal: "Website",
	Utilities: "Settings",
	"E-commerce": "Website",
	Contacts: "CRM",
	Accounts: "Accounting",
});

$.extend(frappe.breadcrumbs.workspace, {
	"Sales Order": "Selling",
});
